module.exports = __webpack_public_path__ + "img/my-card.e3f113c2.png";